import { MigratableJson } from '../MigratableJson';
import { IMAGE_NODE_NAME } from '@builder4/shared/utils/constants';
import type { NodeDetachablePropsState } from '@builder4/shared/types/craft';

/**
 * Migration v6: Migrates Image components from old breakpoint system (detachablePropsState)
 * to new breakpoint system (props.tablet and props.mobile)
 *
 * Steps:
 * 1. Find all Image nodes.
 * 2. If detachablePropsState exists, move tablet/mobile into props.tablet / props.mobile.
 * 3. Remove detachablePropsState after migration.
 */
export default function toV6<T extends MigratableJson>(data: T): T {
  const allNodes = data.getAllNodes();

  for (const { node } of allNodes) {
    if (node.displayName !== IMAGE_NODE_NAME) continue;

    const custom = node.custom || {};
    const detachablePropsState = custom.detachablePropsState as
      | NodeDetachablePropsState
      | undefined;

    // Skip if detachablePropsState is missing or empty
    if (!detachablePropsState || Object.keys(detachablePropsState).length === 0) continue;

    const props = { ...(node.props || {}) } as Record<string, unknown>;

    if (
      detachablePropsState.tablet &&
      typeof detachablePropsState.tablet === 'object' &&
      Object.keys(detachablePropsState.tablet).length > 0
    ) {
      if (!props.tablet) props.tablet = {};
      Object.assign(props.tablet as object, detachablePropsState.tablet);
    }

    if (
      detachablePropsState.mobile &&
      typeof detachablePropsState.mobile === 'object' &&
      Object.keys(detachablePropsState.mobile).length > 0
    ) {
      if (!props.mobile) props.mobile = {};
      Object.assign(props.mobile as object, detachablePropsState.mobile);
    }

    delete custom.detachablePropsState;
    node.props = props;
    node.custom = custom;
  }

  return data;
}
